module.exports = __webpack_public_path__ + "static/builder-user@2x-8507eba433cddc7e272130c2c0397851.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/account-locked/builder-user@2x.png
// module id = 2527
// module chunks = 168707334958949